<main class="container-fluid">
        <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
          <section class="col-12 p-4 mb-5">

            <div class="d-flex justify-content-between">
              <div>
                <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
                <label class="h5">Listado de reporte prestadores</label>
              </div>
              <p>
                <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
                  [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
                  Ver filtros
                </button>
              </p>
            </div>

            <div id="filtros" [ngbCollapse]="isCollapsed">
              <div class="card mb-3">
                <div class="card-body">
                  <form [formGroup]="filtro" (submit)="filtrar()">
                    <div class="row">
                      <div class="col-2 form-group" *ngIf="!authService.getRolUser(adminCC)">
                        <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                        <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                          <option class="" value="" selected="true">
                            Seleccione
                          </option>
                          <option class="" *ngFor="let option of camarasLista; let i = index"
                            value="{{option?.codigo_camara}}" [selected]="false">
                            {{option?.desc_camara}}
                          </option>
                        </select>
                      </div>
                      <div class="col-2 form-group">
                        <label class="small text-secondary" for="activo">Activo</label>
                        <select class="form-control form-control-sm" id="activo" formControlName="activo">
                          <option class="" value= "" selected="true">
                            Seleccione
                          </option>
                          <option class="" [ngValue]= "1" [selected]="false">
                            Activo
                          </option>
                          <option class="" [ngValue]= "0" [selected]="false">
                            Inactivo
                          </option>
                        </select>
                      </div>
                      <div class="col-2 form-group">
                        <label class="small text-secondary" for="usuario">Usuario</label>
                        <input id="usuario" formControlName="usuario" type="text" class="form-control form-control-sm">
                      </div>
                      <div class="col-2 form-group">
                          <label class="small text-secondary" for="correo_electronico">Correo electrónico</label>
                          <input id="correo_electronico" formControlName="correo_electronico" type="text" class="form-control form-control-sm">
                       </div>
                       <div class="col-2 form-group">
                          <label class="small text-secondary" for="numero_identificacion">Nit</label>
                          <input id="numero_identificacion" formControlName="numero_identificacion" type="text" class="form-control form-control-sm">
                       </div>
                       <div class="col-2 form-group">
                          <label class="small text-secondary" for="razon_social">Nombre o Razón social</label>
                          <input id="razon_social" formControlName="razon_social" type="text" class="form-control form-control-sm">
                       </div>
                       <div class="col-2 form-group">
                          <label class="small text-secondary alineacion-label" for="numero_identificacion_representante_legal">Id Representante Legal</label>
                          <input id="numero_identificacion_representante_legal" formControlName="numero_identificacion_representante_legal" type="text" class="form-control form-control-sm">
                       </div>
                       <div class="col-2 form-group">
                          <label class="small text-secondary" for="nombre_representante_legal">Nombre del representante legal</label>
                          <input id="nombre_representante_legal" formControlName="nombre_representante_legal" type="text" class="form-control form-control-sm">
                       </div>
                       <div class="col-2 form-group">
                          <label class="small text-secondary alineacion-label" for="patrimonio_neto">Patrimonio</label>
                          <input id="patrimonio_neto" formControlName="patrimonio_neto" type="text" class="form-control form-control-sm">
                       </div>

                      <div class="d-flex flex-row alineacion-label">
                        <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                          (click)="limpiar()">Limpiar</button>
                        <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical" type="submit" [disabled]="minFiltroCheck()">Filtrar</button>
                      </div>
                    </div>
                    <div class="row" *ngIf="minFiltroCheck()">
                      <div class="col-6 form-group">
                        <small class="text-danger">*Para filtrar al menos llene un campo</small>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <app-tablas [page] = "paginaActual" [headers]="headerTabla" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
                class="table-responsive">
                <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
                  <td>{{item.descripcion_camara}}</td>
                  <td>{{item.razon_social}}</td>
                  <td>{{item.numero_identificacion}}</td>
                  <td>{{item.descripcion_departamento}}</td>
                  <td>{{item.descripcion_municipio}}</td>
                  <td>{{item.usuario}}</td>
                  <td>{{item.activo | validacionActivo}}</td>
                  <td>{{item.numero_identificacion_representante_legal}}</td>
                  <td>{{item.nombre_representante_legal}}</td>
                  <td>{{item.correo_electronico}}</td>
                  <td>{{item.correo_electronico_reportado}}</td>
                  <td>{{item.telefono_reportado_1}}</td>
                  <td>{{item.telefono_reportado_2}}</td>
                  <td>{{item.patrimonio_neto}}</td>
                </tr>
              </app-tablas>
            </div>
          </section>
        </article>
      </main>
